import * as React from "react";
import { useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Input } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";

export const ListDialog = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage] = useState(15);
    const [rowClicked, setRowClicked] = useState(null);
    const [searchText, setSearchText] = useState(""); // Adăugăm starea pentru textul căutat

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
        setCurrentPage(1); // Resetăm pagina când utilizatorul introduce text nou pentru a afișa rezultatele filtrate de la pagina 1
    };

    const paginate = (pageNumber) => {
        setRowClicked(null);
        setCurrentPage(pageNumber);
    };

    const indexOfLastItem = currentPage * perPage;
    const indexOfFirstItem = indexOfLastItem - perPage;

    // Filtrăm lista în funcție de textul căutat
    const filteredItems = (searchText === "") ? props.data : props.data.filter(item =>
        item.text.toLowerCase().includes(searchText.toLowerCase())
    );


    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    const handleSelect = () => {
        // aflu elementul selectat in lista filtrata
        let current = currentItems[rowClicked];
        // find the index of the current item in the original list
        let index = props.data.findIndex(item => item.id === current.id);   
        // return the index to the parent component
        props.handleReturn(index);
        // inchid dialogul
        props.handleDialog();
    };

    return (
        <Dialog title={props.title ?? ""} onClose={props.handleDialog}>
            <div style={{ margin: "10px", width: "600px" }}>
                {currentItems.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => setRowClicked(index)}
                        className={
                            rowClicked !== null && rowClicked === index
                                ? "dwgrid_sel"
                                : ""
                        }
                    >
                        <span>{(currentPage - 1) * perPage + index + 1} </span>{" "}
                        <span>{item.text}</span>
                    </div>
                ))}
            </div>

            <div className="w400 ">
                {/* Adăugăm evenimentul de schimbare a căutării */}
                <Input
                    name="search"
                    placeholder="Caută"
                    className="fl w300"
                    value={searchText}
                    onChange={handleSearchChange}
                />
                <Button icon="search" themeColor={"primary"} className="">
                    Cauta
                </Button>
            </div> 

            <div className="mt10">
                <div className="w70 fl mt5">
                    <span className="">
                        {(currentPage - 1) * perPage + 1}{" "}
                    </span>{" "}
                    - <span> {Math.min(currentPage * perPage, filteredItems.length)}</span>
                </div>
                <div className="fl">
                    <button
                        className="pagination-button"
                        onClick={() => paginate(1)}
                        disabled={currentPage === 1}
                    >
                        |&lt;
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        &lt;
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() => paginate(currentPage + 1)}
                        disabled={
                            currentPage ===
                            Math.ceil(filteredItems.length / perPage)
                        }
                    >
                        &gt;
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() =>
                            paginate(
                                Math.ceil(filteredItems.length / perPage)
                            )
                        }
                        disabled={
                            currentPage ===
                            Math.ceil(filteredItems.length / perPage)
                        }
                    >
                        &gt;|
                    </button>
                </div>
            </div>

            <DialogActionsBar>
                <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                    onClick={() => handleSelect(rowClicked)}
                >Selecteaza</button>
            </DialogActionsBar>
        </Dialog>
    );
};
